<template>
    <div>
        <h5 class="title is-5 has-text-primary">
            {{ $t("active-rooms.title") }} - {{ roomsCount }}
        </h5>
        <div>
            <div v-if="isLoading">
                <Loading />
            </div>
            <div v-else>
                <div v-if="haveRooms" class="rooms-container">
                    <div class="room-item" v-for="room in rooms" :key="room.id">
                        <ActiveRoom :room="room" :key="room.id" />
                    </div>
                </div>
                <div v-else>
                    <p>{{ $t("active-rooms.empty-rooms") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "@/components/Loading";
import ActiveRoom from "./ActiveRoom";
import { RepositoryFactory } from "@/services/api";

export default {
    name: "active-rooms",
    components: {
        ActiveRoom,
        Loading,
    },
    data() {
        return {
            rooms: [],
            isLoading: false,
        };
    },
    mounted() {
        this.retrieveRooms();
    },
    computed: {
        haveRooms() {
            return this.rooms.length > 0;
        },
        roomsCount() {
            return this.rooms.length;
        },
    },
    methods: {
        async retrieveRooms() {
            this.isLoading = true;

            let response = await RepositoryFactory.dashboard.getOpenRooms({
                take: 10,
            });
            this.rooms = response.data.items;

            this.isLoading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.room-item {
    padding-bottom: 1rem;
    + .room-item {
        border-top: 1px solid gray;
        padding-top: 1rem;
    }
}

.rooms-container {
    max-height: 32vh;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>